export default __webpack_public_path__ + "locales/ru/EmptyView.json?hash=7b5dc046c26df7e29445178ee0ff0fe5";